import { createExternalRouteRef } from '@backstage/core-plugin-api';

const catalogIndexRouteRef = createExternalRouteRef({
  id: "catalog-index",
  optional: true,
  defaultTarget: "catalog.catalogIndex"
});

export { catalogIndexRouteRef };
//# sourceMappingURL=routes.esm.js.map
